import {
  Grid,
  IconButton,
  ListItemButton,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { BarChart3 as AnalyticsOutlinedIcon, BarChart3 as AnalyticsIcon, Info as InfoIcon, Info as InfoOutlinedIcon, CalendarClock as EventNoteOutlinedIcon, CalendarClock as EventNoteIcon, ArrowLeft as KeyboardBackspaceOutlinedIcon, Images as CollectionsOutlinedIcon, Images as CollectionsIcon } from "lucide-react";
import { PERMISSIONS } from "@/app/_utils/permissions";
interface SideNavigationProps {
  campaignId: any;
}

export default function SideNavigation(props: SideNavigationProps) {
  const { campaignId } = props;
  const theme = useTheme();
  const { pathname: path } = useLocation();
  const navigate = useNavigate();

  return (
    <Grid
      container
      sx={{
        minWidth: "200px",
        position: "relative",
      }}
    >
      <Grid
        container
        justifyContent={"start"}
        alignContent={"start"}
        sx={{
          top: 0,
          position: "sticky",
          height: "calc(100vh - 50px)",
          width: "200px",
          background: `white`,
          borderRight: `var(--mh-border-soft)`,
          boxShadow: `0px 0px 10px  ${theme.palette.primary.main}09`,
        }}
      >
        <Grid xs={12} sx={{ pl: 1, pt: 1 }}>
          <IconButton
            disableRipple
            size={"small"}
            onClick={() => navigate(`/admin/marketing/campaigns`)}
            sx={{
              color: "var(--mh-primary)",
              columnGap: 1,
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            <KeyboardBackspaceOutlinedIcon style={{ height: "20px" }} />
            <Typography variant="body2" fontWeight={"bold"}>
              Back to campaigns
            </Typography>
          </IconButton>
        </Grid>

        <Grid container direction={"column"} sx={{ p: 1, width: "100%" }}>
          {sideNavOptions.map((menuItem) => {
            const { label, link } = menuItem;
            const selected = path?.includes(`${menuItem.link}`);
            return (
              <Grid key={link} sx={{ pb: 0.5 }}>
                <StyledListItemButton
                  disableRipple
                  onClick={() =>
                    navigate(
                      `/admin/marketing/campaigns/${campaignId}${link}`,
                      { replace: true }
                    )
                  }
                  selected={selected}
                  sx={{
                    borderRadius: "8px !important",
                  }}
                >
                  {selected ? (
                    <menuItem.selectedIcon style={{ width: "15px", height: "15px" }} />
                  ) : (
                    <menuItem.icon style={{ width: "15px", height: "15px" }} />
                  )}
                  <Typography sx={{ pl: 0 }}>{label}</Typography>
                </StyledListItemButton>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}

export const sideNavOptions = [
  {
    icon: InfoOutlinedIcon,
    selectedIcon: InfoIcon,
    label: "Overview",
    link: "/overview",
    permission: PERMISSIONS.CAMPAIGN_WRITE,
  },
  {
    icon: AnalyticsOutlinedIcon,
    selectedIcon: AnalyticsIcon,
    label: "Performance",
    link: "/performance",
    permission: PERMISSIONS.CAMPAIGN_WRITE,
  },
  {
    icon: CollectionsOutlinedIcon,
    selectedIcon: CollectionsIcon,
    label: "Content",
    link: "/content",
    permission: PERMISSIONS.PAGE_CAMPAIGNS,
  },
  {
    icon: EventNoteOutlinedIcon,
    selectedIcon: EventNoteIcon,
    label: "Schedule",
    link: "/schedule",
    permission: PERMISSIONS.PAGE_CAMPAIGNS,
  },
];

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  columnGap: "10px",
  ".MuiTypography-root": {
    fontSize: "13px",
  },
  ":hover": {
    backgroundColor: `${theme.palette.primary.main}08 !important`,
    borderRadius: "3px !important",
  },
  "&.Mui-selected": {
    backgroundColor: `${theme.palette.primary.main}08 !important`,
    color: theme.palette.primary.main,
    borderRadius: "5px !important",
  },
}));
